<template>
	<v-card flat outlined class="wall-card">
		<v-card-title class="px-4">
			{{ $vuetify.lang.t("$vuetify.views.tasks.taskWall.todo") }}
		</v-card-title>
		<v-card-text class="px-4">
				<div key="no-tasks" v-if="!todo.length && !isloading">
					<v-img
						src="@/assets/images/todo-placeholder.svg"
						class="mx-auto hero-image"
					/>
					<div class="text-muted my-5 no-tasks-caption text-center">
						{{
							$vuetify.lang.t(
								"$vuetify.views.tasks.taskWall.noTasks"
							)
						}}
					</div>
				</div>

				<div v-else key="with-tasks">
						<v-checkbox
							v-for="task in todo"
							:key="task.id"
							@change="finishTask(task)"
							color="accent"
							class="pa-0 ma-0 checkbox"
							:ripple="false"
						>
							<template v-slot:label>
								<div class="d-flex flex-column">
									<div
										class="grey--text text--darken-3 font-weight-medium"
									>
										{{ task.title }}
									</div>
									<div
										v-if="task.deadline"
										class="grey--text caption font-weight-medium"
									>
										{{
											$vuetify.lang.t(
												"$vuetify.views.tasks.taskWall.hour"
											)
										}}
										{{
											$moment(
												task.deadline
											).local().format("HH:mm")
										}}
										<span
											v-if="isOverlate(task.deadline)"
											class="red--text font-weight-medium"
										>
											{{
												$vuetify.lang.t(
													"$vuetify.views.tasks.taskWall.expired"
												)
											}}
										</span>
									</div>
								</div>
							</template>
						</v-checkbox>
				</div>

			<v-btn
					@click.stop="activeAddTaskInput()"
					v-if="!addTaskInputVisible"
					color="accent"
					elevation="0"
					height="32"
					block
				>
					<v-icon>mdi-plus</v-icon>
					{{ $vuetify.lang.t("$vuetify.views.tasks.taskWall.add") }}
				</v-btn>
				<v-btn
					v-if="!addTaskInputVisible"
					:to="{ name: 'Tasks' }"
					color="secondary"
					elevation="0"
					height="32"
					block
					class="mt-2"
				>
					{{
						$vuetify.lang.t("$vuetify.views.tasks.taskWall.goTasks")
					}}
				</v-btn>
			<div v-if="addTaskInputVisible" class="mt-3">
				<div >
					<v-text-field
						ref="input"
						@keydown.enter="addTask"
						v-model="taskName"
						:placeholder="
							$vuetify.lang.t('$vuetify.views.tasks.taskWall.add')
						"
						outlined
						hide-details
						height="40"
						class="input-text font-weight-medium font-14"
					>
					</v-text-field>
					<div class="d-flex flex-row mt-3">
						<v-btn
							@click="deactiveAddTaskInput"
							elevation="0"
							text
						>
							{{ $vuetify.lang.t("$vuetify.cancel") }}
						</v-btn>
						<v-btn
							@click="addTask"
							color="secondary"
							elevation="0"
							class="ml-auto px-5"
							:loading="saving"
							width="120px"
						>
							<v-icon>mdi-check</v-icon>
							{{
								$vuetify.lang.t("$vuetify.views.tasks.taskMenu.add")
							}}
						</v-btn>

					</div>

				</div>


			</div>
		</v-card-text>
	</v-card>
</template>

<script>
import axios from "axios";

export default {
	data() {
		return {
			todo: [],
			addTaskInputVisible: false,
			taskName: "",
			haveTasks: "",
			isloading: true,
			saving: false
		};
	},
	computed: {
		today() {
			return this.$moment().local().endOf('day');
		},
	},
	methods: {
		isOverlate(deadline) {
			if (
				this.$moment().local().format("x") >
				this.$moment(deadline).local().format("x")
			) {
				return true;
			} else {
				return false;
			}
		},
		activeAddTaskInput() {
			this.addTaskInputVisible = true;
			this.$nextTick(() => {
				this.$refs.input.focus();
			})

		},
		deactiveAddTaskInput() {

			this.taskName = "";
			this.addTaskInputVisible = false;
		},
		async addTask() {
			if (this.taskName) {
				this.saving = true;
				await axios
					.post(`tasks`, {
						user_id: this.$store.state.auth.user.id,
						title: this.taskName,
						status: "unfinished",
						deadline: this.today
					})
					.then((response) => {
						this.taskName = "";
						this.todo.unshift(response.data.data);
						this.addTaskInputVisible = false;
						this.$snackbar.success('Pomyślnie dodano zadanie')
					})
					.catch((error) => {
						this.$snackbar.error({error});
						console.log("ADD TASKS ERROR", error);
					});
				this.saving = false;
			}
		},
		async finishTask(task) {
			await axios
				.patch(`tasks/${task.id}`, {
					user_id: task.user_id,
					title: task.title,
					status: "finished",
				})
				.then(() => {
					const idx = this.todo.findIndex(
						(todoTask) => todoTask.id === task.id
					);
					setTimeout(() => {
						this.todo.splice(idx, 1);
					}, 0);
					this.updateTask(task);
				})
				.catch((error) => {
					console.log("UPDATE TASKS ERROR", error);
				});
		},
		async getTasks() {
			this.isloading = true;
			await axios
				.get("tasks", {
					params: {
						page: 1,
						filter_period: "today",
						filter_status: "unfinished",
					},
				})
				.then((response) => {
					this.todo = response.data.data;
				})
				.catch((error) => {
					console.log("GET TASKS ERROR", error);
				})
				.finally(() => {
					this.isloading = false;
				});
		},
	},
	async created() {
		await this.getTasks();
	},
};
</script>

<style lang="scss" scoped>
.hero-image {
	max-width: 200px;
}
.no-tasks-caption {
	font-size: 14px;
}

.v-input.pa-0.ma-0.checkbox.v-input--is-label-active.v-input--is-dirty.v-input--selection-controls.v-input--checkbox.accent--text {
	div {
		color: var(--v-grey-base) !important;
	}
}

.width-100 {
	width: 100%;
}

.fade-out-enter,
.fade-out-leave-to {
	opacity: 0;
}

.fade-out-enter-to,
.fade-out-leave {
	opacity: 1;
}

.fade-out-enter-active,
.fade-out-leave-active {
	transition: opacity 0.7s;
}
</style>
